"use strict";

exports.__esModule = true;
exports.default = void 0;
var _routes = _interopRequireDefault(require("./routes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const config = {
  onAuthenticateSuccess: (props, response) => {

    //console.log('onAuthenticateSuccess', props.dispatch);
  },
  onResetPasswordSuccess: props => {
    props.history.push('/sign-in');
  },
  onSignInRedirect: '/sign-in-redirect',
  onSignOutRedirect: '/sign-out-redirect',
  onSignUpRedirect: '/sign-up-redirect',
  passwordRules: {
    minLength: 8,
    hasNumber: true,
    hasUppercase: true,
    hasLetter: true
  },
  signupFromInvitation: {
    schema: {
      GivenName: {
        displayName: 'First Name',
        type: 'String',
        rules: [],
        value: ''
      },
      FamilyName: {
        displayName: 'Last Name',
        type: 'String',
        rules: [],
        value: ''
      },
      Email: {
        displayName: 'Email',
        type: 'String',
        rules: [],
        value: ''
      },
      Password: {
        displayName: 'Password',
        type: 'String',
        rules: [],
        value: ''
      }
    },
    view: [{
      id: 'GivenName'
    }, {
      id: 'FamilyName'
    }, {
      id: 'Email'
    }]
  },
  routes: _routes.default
};
var _default = exports.default = config;
module.exports = exports.default;